import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from "./state/store";
import BootstrapVueNext from 'bootstrap-vue-next';
import addMomentFilters from './utils/moment.filters';
import setupAppComponents from './utils/globalComponents';
import addAuthorizeDirective from './utils/authorize.directive'
import addGlobalLabelsProps from './utils/labels.helpers'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
const defaultToastOptions = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 10,
    newestOnTop: true,
    filterToasts: toasts => {
        // Keep track of existing types
        const types = {};
        return toasts.reduce((aggToasts, toast) => {
            if (toast.isWs === true) {
                aggToasts.push(toast);
            } else {
                // Check if type was not seen before
                if (!types[toast.type]) {
                    aggToasts.push(toast);
                    types[toast.type] = true;
                }
            }
            
            return aggToasts;
        }, []);
    }
}

import i18n from './utils/i18n';

import { vMaska } from "maska";

import './assets/scss/app.scss';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import { useWebsocket } from './services/websocket';
var ws = useWebsocket();
ws.tryStart();

//todo mover para arquivo especifico
Array.prototype.firstOrDefault = function (predicate) {
    if (typeof predicate !== 'function') {
        throw new TypeError('Predicate must be a function');
    }

    for (let i = 0; i < this.length; i++) {
        if (predicate(this[i], i, this)) {
            return this[i];
        }
    }

    return null;
};

const app = createApp(App);

addMomentFilters(app);
addAuthorizeDirective(app);
addGlobalLabelsProps(app);
setupAppComponents(app)

app.use(router)
    .use(store)
    .use(BootstrapVueNext)
    .use(i18n)
    .use(ws)
    .use(Toast, defaultToastOptions)
    .directive("maska", vMaska)
    .mount('#app');
